import { Logger } from '@main/utils/logger';
import type { TeammateAvailabilityChangedEventPublisher } from './teammate-availability-changed.usecase';

export class TeammateAvailabilityChangedPublisher
  implements TeammateAvailabilityChangedEventPublisher
{
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish(): Promise<void> {
    this.logger.info('TeammateAvailabilityChanged:', {
      action: 'TeammateAvailabilityChanged',
    });
  }
}
